import { axiosV2 } from 'interceptors/axios';
import { Dispatch } from 'redux';
import { ApiQueryParams } from 'types/ApiQueryParams';
import { dispatchError } from 'utils/dispatchError';
import { decryptResponse } from 'utils/token';

type GetPartnerSharesProps = {
  partnerId: string;
  params: ApiQueryParams;
};

export const getPartnerShares =
  ({ partnerId, params }: GetPartnerSharesProps) =>
  async (dispatch: Dispatch) => {
    const query = { params: { partnerId, ...params } };

    try {
      const { data } = await axiosV2.get('/partners/shares', query);

      const decodedData = await decryptResponse(data);

      return decodedData;
    } catch (error) {
      dispatchError(error, dispatch);
    }
  };
